__turbopack_context__.v({
  "headerWrapper": "customers-module-scss-module__38Sbta__headerWrapper",
});
